import courseReducer from './reducers';
import * as courseActions from './actions';

export default courseReducer;

export { courseActions };
